import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DropdownWithClear from "./dropdownWithClear";
import LabelInput from "./labelInput";
import { ShipmentStatusList } from "../Utils/dataConstant";
import "../Screen/Admin/DispachOrder/dispachOrder.css"; 
import InputField from "./inputField";
import DatePicker from "./datePicker";
import moment from "moment";
import { containsNumber } from "../Utils/validators";
import { validateValueWithoutSpace } from "../Utils/validators";
import { validateIsNumberOnlyErrMsg } from "../Utils/errorMsg";
import { getOrdersList, addShipment, updateShipment } from "../Screen/Publication/publicationSlice";
import { showSnackbar, hideSnackbar } from "../store/slices/snackbarSlice";
interface props {
  open: boolean;
  handleClose: Function;
  data?: any;
}

export default function InvoicePopUP(props: props) {
  const dispatch: Function = useDispatch<AppDispatch>();
  const { open, handleClose,  data  } = props;
 

  useEffect(() => {
  
  }, [ ]);

  function closePopup(
    event: React.MouseEvent<SVGSVGElement, MouseEvent>
  ): void {
    handleClose();
  }
 
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modelChat"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className="dispachModeldiv p-3 col-md-6">
            <div className="d-flex justify-content-between">
              <h5 className="fw-bold mt-1">Invoice</h5>
              <div>
                <HighlightOffIcon
                  color="primary"
                  className="cursor"
                  onClick={closePopup}
                />{" "}
              </div>
            </div>
            
            <div className="px-5  mt-5"> 
               
            {/* <iframe src={data?.document} width="100%" height="100%"> 2  <a href="home.pdf">Download the PDF</a>3</iframe> */}
            {/* <img
                       className="p-1 cursor" 
                       src={data?.document}
                       style={{
                         width: "50px",
                         height: "50px",
                       }}
                       alt={"invoice"}
                      
                     /> */}
                     {/* <embed
	 src={data?.document}
	type="application/pdf"
	width="100%"
	height="500px"
/> */} 
              
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
